import {
    GET_DOCUMENT_REQUESTS_FAIL,
    GET_DOCUMENT_REQUESTS_SUCCESS,
    ADD_DOCUMENT_REQUEST_SUCCESS,
    ADD_DOCUMENT_REQUEST_FAIL,
    UPDATE_DOCUMENT_REQUEST_SUCCESS,
    UPDATE_DOCUMENT_REQUEST_FAIL,
    DELETE_DOCUMENT_REQUEST_SUCCESS,
    DELETE_DOCUMENT_REQUEST_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    documentRequests: [],
    error: null,
    loading: true
};

const documentRequestReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des documentRequests
        case GET_DOCUMENT_REQUESTS_SUCCESS:
            return {
                ...state,
                documentRequests: action.payload, // tableau d'objets documentRequest
                loading: false,
                error: null
            };

        case GET_DOCUMENT_REQUESTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une documentRequeste
        case ADD_DOCUMENT_REQUEST_SUCCESS:
            return {
                ...state,
                documentRequests: [action.payload, ...state.documentRequests], // ajoute au début du tableau
                error: null
            };

        case ADD_DOCUMENT_REQUEST_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une documentRequeste
        case UPDATE_DOCUMENT_REQUEST_SUCCESS:
            return {
                ...state,
                documentRequests: state.documentRequests.map(documentRequest =>
                    documentRequest.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet documentRequest
                        : documentRequest
                ),
                error: null
            };

        case UPDATE_DOCUMENT_REQUEST_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une documentRequeste
        case DELETE_DOCUMENT_REQUEST_SUCCESS:
            return {
                ...state,
                documentRequests: state.documentRequests.filter(
                    documentRequest => documentRequest.id !== action.payload
                ),
                error: null
            };


        case DELETE_DOCUMENT_REQUEST_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default documentRequestReducer;
